// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__KT556","spin":"loading_spin__nnRB0"};